import { useQuery, UseQueryOptions } from 'react-query';

import { fetchJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { INVITE_STATUSES, ROLES } from 'app/developer-v3/constants';

import useNotify from './useNotify';

import type { Member } from 'app/developer-v3/types/member';

const QUERY_KEY_PREFIX = 'query-collaborators';
const getQueryKey = (integrationId: string) =>
  `${QUERY_KEY_PREFIX}-${integrationId}`;

function formatResponseBody(body: any): Member[] {
  const { objects } = body;
  const members = objects ?? [];

  return members.map((member: any) => ({
    email: member.email ?? '',
    gravatar: member.gravatar ?? '',
    id: member.id ?? '',
    name: member.name ?? '',
    status: member.status ?? INVITE_STATUSES.waiting,
    role: member.role ?? ROLES.collaborator,
  }));
}

function useQueryCollaborators(
  integrationId: string,
  options?: UseQueryOptions<Member[], Error, Member[]>
) {
  const notify = useNotify();

  const queryKey = getQueryKey(integrationId);
  const url = new URL(
    `/api/platform/cli/apps/${encodeURIComponent(
      integrationId
    )}/limited_collaborators`,
    ZAPIER_APP_BASE_URL
  );

  const { data, error, ...rest } = useQuery({
    initialData: [],
    queryKey,
    queryFn: async () => formatResponseBody(await fetchJson(url.href)),
    ...options,
  });

  if (error) {
    notify.failure('Failed to fetch collaborators.');
  }

  return { ...rest, collaborators: data, error, queryKey };
}

export default useQueryCollaborators;
export { getQueryKey, QUERY_KEY_PREFIX };
